import { WebsocketService } from './../../../shared/src/lib/service/websocket.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../shared/src/lib/service/authentification.service';
import { AppStateManage } from './manage.states';
import { DictionnaryService } from '../../../shared/src/lib/service/dictionnary.service';
import * as authActions from '../../../shared/src/lib/store/actions/auth.actions';
import * as userActions from '../../../shared/src/lib/store/actions/user.actions';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss']
})
export class ManageComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private dictionnaryService: DictionnaryService,
    private translateService: TranslateService,
    private store: Store<AppStateManage>,
    private router: Router,
    private adapter: DateAdapter<any>,
  ) {
    this.adapter.setLocale('fr');
  }

  ngOnInit(): void {
    this.login();
    this.setTranslation()
  }

  login() {
    if (this.authenticationService.accessToken
      && this.authenticationService.xBundleRecurring) {
      this.store.dispatch(authActions.loginSuccess(
        {
          payload: {
            access_token: this.authenticationService.accessToken,
            xBundleRecurring: this.authenticationService.xBundleRecurring
          }
        }
      ));
    }
  }

  /**
 * Lancement de la traduction.
 */
  setTranslation() {
    const _lang = localStorage.getItem('language');
    this.translateService.setDefaultLang(_lang);
    this.translateService.use(_lang);
    this.dictionnaryService.getDictionnary2(_lang)
      .subscribe(res => {
        if (res) {
          this.translateService.setTranslation(_lang, res);
        }
      });
  }
}
